import React, { useEffect, useState } from 'react';
import './App.css';

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import HomeScreen from './screens/HomeScreen'
import CoursesScreen from './screens/CoursesScreen';
import CourseIntroScreen from './screens/CourseIntroScreen';
import SignInScreen from './screens/SignInScreen';
import { auth } from './services/Firebase';
import SignUpScreen from './screens/SignUpScreen';
import PublicRoute from './router/PublicRoute';
import PrivateRoute from './router/PrivateRoute';

import './App.css';

function App() {

  const [authentificated, setAuthentificated] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    auth().onAuthStateChanged((user) => {
      if (user) {
        setAuthentificated(true);
      } else {
        setAuthentificated(false);
      }

      setLoading(false);

    })

    return () => {

    }
  }, []);

  if (loading) return <div>Chargement...</div>

  return (
    <Router>
      <Switch>
        <Route exact path="/" component={HomeScreen} />
        <PrivateRoute authenticated={authentificated} path="/courses" component={CoursesScreen} />
        <PrivateRoute authenticated={authentificated} path="/course-intro" component={CourseIntroScreen} />
        <PublicRoute authenticated={authentificated} path="/connexion" component={SignInScreen} />
        <PublicRoute authenticated={authentificated} path="/inscription" component={SignUpScreen} />
        <Route exact path="*">
          Page introuvable...
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
